module.exports = __webpack_public_path__ + "img/whatsapp-globe.38b847cf.png";